import React from 'react';
import './Awards.css';
import { Link } from 'react-router-dom';

const awardMetrics = [
  {
    value: '4',
    label: 'FIRST Impact Awards',
  },
  {
    value: '2',
    label: 'Championship Impact Finalist',
  },
  {
    value: '10',
    label: 'Blue Banners',
    featured: true,
  },
  {
    value: '3',
    label: 'Winner Awards',
  },
  {
    value: '1',
    label: 'Woodie Flowers Finalist Award',
  },
];

function Awards() {
  return (
    <section
      className="awards"
      id="awards"
      itemScope
      itemType="https://schema.org/ItemList"
    >
      <header className="awards-heading">
        <h2 itemProp="name">Our Awards</h2>
      </header>
      <meta itemProp="description" content="INTEGRA 3646's robotics competition achievements and recognitions" />
      <ul
        className="awards-list-main"
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ItemList"
      >
        {awardMetrics.map((metric, index) => (
          <li
            key={`${metric.value}-${metric.label}`}
            className={metric.featured ? 'award-stat-card award-stat-card--blue-banner' : 'award-stat-card'}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <span className="award-metric-value" itemProp="name">{metric.value}</span>
            <span className="award-metric-label">{metric.label}</span>
            <meta itemProp="position" content={(index + 1).toString()} />
          </li>
        ))}
      </ul>
      <Link
        to="/awards"
        className="awards-button"
        aria-label="View all of our awards and achievements"
      >
        See All Awards
      </Link>
    </section>
  );
}

export default Awards;
